import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

import connect from './utils/connect';
import { HOME_PAGE, INSIGHT_PAGE } from './constants/config';

function RedirectToClient({ user, shouldAddPath, setAddPath, client }) {
    const { pathname, search } = useLocation();
    useEffect(() => {
        if (user.clients.length > 0 && setAddPath) {
            setAddPath(!shouldAddPath);
        }
    }, [setAddPath, shouldAddPath, user.clients.length]);

    if (user.clients.length === 0) return null;
    const clientId = user.selectedClientId;

    const valuationStatusId = client ? client.valuationStatusId : null;

    const showOnboardingOnly = valuationStatusId == '1';

    const getBasicPath = () => {
        if (!client.permissions.includes(HOME_PAGE)) {
            // If user doesn't have HOME_PAGE permission, redirect to insights
            // but only if they have INSIGHT_PAGE permission to avoid redirect loops
            if (client.permissions.includes(INSIGHT_PAGE)) {
                return `/c/${clientId}/insights`;
            }
            // Fallback to client-configuration which doesn't require permissions
            return `/c/${clientId}/client-configuration`;
        }

        if (showOnboardingOnly) {
            return `/c/${clientId}/client-configuration`;
        }
        return `/c/${clientId}`;
    };

    const basicPath = getBasicPath();

    const redirectUrl =
        pathname && shouldAddPath
            ? `${basicPath}${pathname}${search}`
            : basicPath;

    return <Navigate to={redirectUrl} />;
}

RedirectToClient.propTypes = {
    user: PropTypes.object.isRequired,
    shouldAddPath: PropTypes.bool,
    setAddPath: PropTypes.func,
    client: PropTypes.object,
};

export default connect(['user'])(RedirectToClient);
